export default __webpack_public_path__ + "static/media/brazil-icon.fecad7f8.svg";